<template>
    <div class="dflex fw">
        <div :class="$style.step4" class="dflex mb40">
            <p class="yel fs50" :class="$style.step41">1</p>
            <img src="../assets/hkid.png" alt="" width="70" height="60" class="mr35">
            <p class="fs18 fw500 pt15">{{$t('l2')}}</p>
        </div>
        <div :class="$style.step4" class="dflex mb40">
            <p class="yel fs50" style="width:50px;">2</p>
            <img src="../assets/doc.png" alt="" width="70" height="60" class="mr35">
            <div style="width: 300px;line-height: 1.4;">
                <p class="fs18 fw500 pt15">{{$t('l3')}}</p>
                <p class="fs14">- {{$t('l31')}}</p>
                <p class="fs14">- {{$t('l32')}}</p>
                <p class="fs14">- {{$t('l33')}}</p>
                <p class="fs14">- {{$t('l34')}}</p>
                <p class="fs14">- {{$t('l35')}}</p>
            </div>
        </div>
        <div :class="$style.step4" class="dflex mb40">
            <p class="yel fs50" style="width:54px;">3</p>
            <img src="../assets/loc.png" alt="" width="70" height="60" style="margin-right:30px;">
            <div style="width: 300px;line-height: 1.4;">
                <p class="fs18 fw500 pt15">{{$t('l4')}}</p>
                <p class="fs14">- {{$t('l41')}}</p>
                <p class="fs14">- {{$t('l42')}}</p>
                <p class="fs14">- {{$t('l43')}}</p>
                <p class="fs14">- {{$t('l44')}}</p>
            </div>
        </div>
        <div :class="$style.step4" class="dflex mb40">
            <p class="yel fs50" style="width:50px;">4</p>
            <img src="../assets/doc.png" alt="" width="70" height="60" class="mr35">
            <div style="width: 300px;line-height: 1.4;">
                <p class="fs18 fw500 pt15">{{$t('l5')}}</p>
                <p class="fs14" style="padding: 10px 0px;">{{$t('l51')}}</p>
                <p class="fs14">- {{$t('l52')}}</p>
                <p class="fs14">- {{$t('l53')}}</p>
                <p class="fs14">- {{$t('l54')}}</p>
            </div>
        </div>
        <div :class="$style.step4" class="dflex mb40">
            <p class="yel fs50"  :class="$style.step41">5</p>
            <img src="../assets/hkid.png" alt="" width="70" height="60" class="mr35">
            <div style="line-height: 1.5;">
                <p class="fs18 fw500 pt15">{{$t('l61')}}</p>
                <p class="fs14">- {{$t('l611')}}</p>
                <p class="fs14">- {{$t('l612')}}</p>
                <p class="fs18 fw500 pt15">{{$t('l62')}}</p>
                <p class="fs14">- {{$t('l621')}}</p>
                <p class="fs14">- {{$t('l622')}}</p>
                <p class="fs14">- {{$t('l623')}}</p>
                <p class="fs14">- {{$t('l624')}}</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Info',
}
</script>
<style module>
.step4 {
    width: 50%;
}
.step41 {
    width:50px;
}
@media screen and (max-width: 770px) {
    .step4 {
        width: 100%;
    }
    .step41 {
        width: 32px;
    }
}
</style>
